"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasAccess = void 0;

var _oauth = require("../oauth");

var hasAccess = function hasAccess(permissions, requiredPermission) {
  // Turn off the ACL when in Client SDK mode
  if (_oauth.OAuth.isInLocalSDKMode) {
    return true;
  }

  if (!permissions || !permissions.length) {
    // user doesn't have the required role
    return false;
  }

  return permissions.indexOf(requiredPermission) > -1;
};

exports.hasAccess = hasAccess;
//# sourceMappingURL=has-access.js.map